import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ScribeLink from 'apps/scribe/ScribeLink';

export default class Button extends PureComponent {
  static propTypes = {
    buy: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    externalLink: PropTypes.bool,
    primary: PropTypes.bool,
    requestInProgress: PropTypes.bool,
    secondary: PropTypes.bool,
    showSuccessMessage: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    tertiary: PropTypes.bool,
    to: PropTypes.string,
  };

  render() {
    const {
      buy,
      children,
      className,
      disabled,
      externalLink,
      primary,
      requestInProgress,
      secondary,
      showSuccessMessage,
      size,
      tertiary,
      to,
      ...passProps
    } = this.props;

    const styles = classNames(
      'gn-button',
      {
        'gn-button--primary': primary || !(secondary || tertiary || buy),
        'gn-button--secondary': secondary,
        'gn-button--tertiary': tertiary,
        'gn-button--buy': buy,
        'gn-button--large': size === 'large',
        'gn-button--small': size === 'small',
        'gn-button--disabled': disabled,
        'gn-button--inProgress': requestInProgress,
        'gn-button--success': showSuccessMessage,
      },
      className,
    );

    if (!to) {
      return (
        <button
          className={styles}
          disabled={disabled}
          {...passProps}
        >
          {children}
        </button>
      );
    }

    if (externalLink) {
      return (
        <ScribeLink
          to={to}
          className={styles}
          {...passProps}
        >
          {children}
        </ScribeLink>
      );
    }

    return (
      <Link
        to={to}
        className={styles}
        {...passProps}
      >
        {children}
      </Link>
    );
  }
}
